import { To } from 'history';
import { Link } from 'react-router-dom';

// material-ui
import ButtonBase from '@mui/material/ButtonBase';
import { SxProps } from '@mui/material/styles';

// project imports
import { APP_DEFAULT_PATH } from 'config';
import LogoIcon from './LogoIcon';
import Logo from './LogoMain';

// ==============================|| MAIN LOGO ||============================== //

interface Props {
  reverse?: boolean;
  isIcon?: boolean;
  sx?: SxProps;
  to?: To;
  logoSize?: number;
  fontSize?: number;
}

export default function LogoSection({ reverse, isIcon, sx, to, logoSize, fontSize }: Props) {
  return (
    <ButtonBase disableRipple component={Link} to={to || APP_DEFAULT_PATH} sx={sx}>
      {isIcon ? <LogoIcon /> : <Logo reverse={reverse} logoSize={logoSize} fontSize={fontSize} />}
    </ButtonBase>
  );
}
